import { i18n } from "@/setup/i18n-setup";
import { TranslateResult } from "vue-i18n";
import { Condition } from "../condition/condition";
import { PropSelectGroup } from "../prop-select/prop-select-group";
import { PropSelectItem } from "../prop-select/prop-select-item";

export enum TextIfValueApplyToTotalOption{
	NO = "",
	YES = "yes",
	EXCLUSIVE = "exclusive"
}

export class TextIfValue {
	Text:string = "";
	ApplyToTotal:TextIfValueApplyToTotalOption = TextIfValueApplyToTotalOption.NO;
	NummericValueTemplate:string | null = null;
	Conditions:Condition[] = [];

	public constructor(data?:any){
		if (!data) return;
		this.Text = data.Text;
		this.ApplyToTotal = data.ApplyToTotal;
		this.NummericValueTemplate = data.NummericValueTemplate;
		this.Conditions = (data.Conditions || []).map((c:any)=>new Condition(c));
	}

	public getJSON(){
		return {
			Text: this.Text,
			ApplyToTotal: this.ApplyToTotal,
			NummericValueTemplate: this.NummericValueTemplate,
			Conditions: this.Conditions.map(c=>c.getJSON())
		};
	}

	public toString(getFieldName:(val:string)=>string):TranslateResult{
		let conditionText = Condition.conditionsToShortString(getFieldName, this.Conditions);
		return i18n.t("components.reportengine.text-if-value", {text: this.Text, conditions: conditionText});
	}

	public static getExtraConditionFields():PropSelectGroup{
		let result = new PropSelectGroup("Metadata", "_metadata_", "");
		result.items = [
			new PropSelectItem("Positie in rapport", "_metadata_.PositionInReport"),
			new PropSelectItem("Positie in groep", "_metadata_.PositionInGroup")
		];
		return result;
	}
}